import React from 'react';
import PropTypes from 'prop-types';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import moment from 'moment';
import { hourMin, shortenedWeekdayDate } from 'Consts/DateFormats';
import { FDHeadlineText, FDTitleText } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';

export const getDuration = (startTime, endTime) => {
  const start = moment(startTime);
  const end = moment(endTime);
  return start.to(end, true);
};


// overrides moments default threshold for mins (default is 44mins)
moment.relativeTimeThreshold('m', 59);

const MeetingTimeDetail = ({
  startTime,
  endTime,
}) => {
  const isMobile = useMobileLayout();
  const date = moment(startTime).format(shortenedWeekdayDate);
  return (
    <Box>
      {isMobile
        ? <FDTitleText value={date} />
        : <FDHeadlineText value={date} size="sm" />
      }
      <span test={'my-meetings-meeting-card-start-time'}>
        {moment(startTime).format(hourMin)}
      </span> - {moment(endTime).format(hourMin)}, {getDuration(startTime, endTime)}
    </Box>
  );
};

MeetingTimeDetail.propTypes = {
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
};

export default MeetingTimeDetail;
